import { useEffect } from 'react';

/**
 * Hook that re-runs the provided callback whenever a native push notification
 * arrives (foreground) or when the user interacts with a notification.
 */
export default function usePushRefresh(callback) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof callback !== 'function') {
      return;
    }

    const handleRefresh = (event) => {
      try {
        callback(event?.detail);
      } catch (error) {
        console.error('usePushRefresh callback error:', error);
      }
    };

    window.addEventListener('pushNotificationReceived', handleRefresh);
    window.addEventListener('pushNotificationAction', handleRefresh);

    return () => {
      window.removeEventListener('pushNotificationReceived', handleRefresh);
      window.removeEventListener('pushNotificationAction', handleRefresh);
    };
  }, [callback]);
}

